import { clearCoupon } from "./coupons";


const PLACE_ORDER = "cart/PLACE_ORDER";


const placeOrder = (payload) => ({
    type: PLACE_ORDER,
    payload
})



export const placeOrderThunkPayInStore = (id, paymentOption, name, phone, tip, address, cartItems, coupon, freeItem, payment_id) => async (dispatch) => { 

    const response = await fetch(`https://hutaoadmin.onrender.com/api/orders/${id}`, { 
        method: 'POST',
        body: JSON.stringify({paymentOption, name, phone, tip, address, cartItems, coupon, freeItem, payment_id}),
        headers: { 
            'Content-Type': 'application/json',
            credentials: 'include',
        },
        credentials: 'include',

    })
    
    if (response.ok) { 
        const data = await response.json();
        dispatch(placeOrder(data))
        localStorage.removeItem('cart')
        localStorage.removeItem('freeItem')
        dispatch(clearCoupon())
    }
}


const initialState = {
  order: {}
};

const orderReducer = (state = initialState, action) => {
  switch (action.type) {
        case PLACE_ORDER:
            return {
                ...state,
                order: action.payload,
            };
      default:
          return state;
  }
};
  
  export default orderReducer;
  
